import { Paper, styled } from '@mui/material';
import { Form } from 'formik';

import FileUploadSvg from '@common/assets/icons/UploadFile.svg';

export const StyledThemePopoverDescriptionWrap = styled(Paper)({
	padding: '8px 16px',
	borderRadius: '8px',
});

export const StyledThemePopoverForm = styled(Form)({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
});

export const ThemeBackgroundImageList = styled('div')({
	display: 'flex',
	gap: '16px',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
});

export const StyledThemePopoverUploadFileIcon = styled(FileUploadSvg)(() => ({
	color: '#75869A',

	width: '18px',
	height: '18px',
}));
